/** Css variable names available for Gtk Applications */
export enum ThemeVariable {
  ForegroundColor = "@theme_fg_color",
  BackgroundColor = "@theme_bg_color",
  TextColor = "@theme_fg_color",
  BaseColor = "@theme_base_color",
  SelectedBackgroundColor = "@theme_selected_bg_color",
  SelectedForegroundColor = "@theme_selected_fg_color",
  InsensitiveForegroundColor = "@insensitive_fg_color",
  InsensitiveBackgroundColor = "@insensitive_bg_color",
  InsensitiveBaseColor = "@insensitive_base_color",
  UnfocusedForegroundColor = "@theme_unfocused_fg_color",
  UnfocusedBackgroundColor = "@theme_unfocused_bg_color",
  UnfocusedBaseColor = "@theme_unfocused_base_color",
  UnfocusedTextColor = "@theme_unfocused_text_color",
  UnfocusedSelectedBackgroundColor = "@theme_unfocused_selected_bg_color",
  UnfocusedSelectedForegroundColor = "@theme_unfocused_selected_fg_color",
  UnfocusedInsensitiveColor = "@unfocused_insensitive_color",
  BorderColor = "@borders",
  UnfocusedBorderColor = "@unfocused_borders",
  WarningColor = "@warning_color",
  ErrorColor = "@error_color",
  SuccessColor = "@success_color",
  ContentViewBackgroundColor = "@content_view_bg",
  TextViewBackgroundColor = "@text_view_bg",
}
